/**
 * 관리자 heavy 발주자 추이
 * ($j.Pages.Admin.HeavyBaljooja / body data-page-name="HeavyBaljooja")
 *
 * 월별 유료티어 중 어플발주 N건 이상(heavy 발주자)의 인원수/비율 추이 + 당월 명단.
 */
import Util from '../../Common/Util';

export default class HeavyBaljooja {
    constructor() {
        this.trendChart = null;
        this.memberChart = null;
        this.$memTable = null;
        this.$declTable = null;
        this.$ordersTable = null;
        this.ordersChart = null;
        this.minBaljoo = 6;
        this.unit = 'month';
        this.trend = [];
        this.selectedBucket = null;
        this.modal = { mbNo: null, name: '', unit: 'month' };
        this.orderModal = null; // {mbNo, name, kind, bucket, unit} — 발주모달 이전/다음 이동용
        this.declWindows = null;
    }

    initialize() {
        this._bindUi();
        this._load();
    }

    _bindUi() {
        $('#hbRefresh').on('click', () => this._load(true));
        $('#hbPeriod').on('change', () => this._load());
        // 명단 이름 클릭 → 회원 발주 추이 모달 (테이블 재생성에도 살아남게 위임)
        $(document).on('click.hbname', '.hb-name', (e) => {
            const $a = $(e.currentTarget);
            // 현재 추이 차트 단위(월/연)에 맞춰 모달도 같은 단위로 시작
            this._openMemberModal(Number($a.data('mb')), String($a.data('name') || ''), this.unit);
        });
        // 추이 모달 월/연 토글
        $(document).on('click.hbname', '.hb-member-unit', (e) => {
            const u = $(e.currentTarget).data('u');
            if (this.modal.mbNo) this._openMemberModal(this.modal.mbNo, this.modal.name, u);
        });
        // 추이 모달 이전/다음 기간 이동
        $(document).on('click.hbname', '.hb-mem-prev', () => this._navMember(-1));
        $(document).on('click.hbname', '.hb-mem-next', () => this._navMember(1));
        // 발주/수주 건수 클릭 → 그 기간(선택 버킷) 완료 오더 목록 표 모달
        $(document).on('click.hbname', '.hb-order', (e) => {
            const $a = $(e.currentTarget);
            this._openOrderModal(Number($a.data('mb')), String($a.data('name') || ''), String($a.data('kind') || 'baljoo'));
        });
        // 오더목록 모달 이전/다음 달(연) 이동
        $(document).on('click.hbname', '.hb-ord-prev', () => this._navOrder(-1));
        $(document).on('click.hbname', '.hb-ord-next', () => this._navOrder(1));
        // 급감표 과거/최근 발주 클릭 → 그 윈도우 완료 발주 오더 목록 모달
        $(document).on('click.hbname', '.hb-range', (e) => {
            const $a = $(e.currentTarget);
            this._openOrderRangeModal(Number($a.data('mb')), String($a.data('name') || ''),
                String($a.data('from')), String($a.data('to')), String($a.data('label')), 'baljoo');
        });
    }

    _shiftBucket(b, unit, d) {
        if (unit === 'year') return String(Number(b) + d);
        const y = Number(String(b).slice(0, 4)), m = Number(String(b).slice(4, 6));
        const dt = new Date(y, m - 1 + d, 1);
        return `${dt.getFullYear()}${String(dt.getMonth() + 1).padStart(2, '0')}`;
    }

    _navOrder(delta) {
        const m = this.orderModal;
        if (!m) return;
        this._openOrderModal(m.mbNo, m.name, m.kind, this._shiftBucket(m.bucket, m.unit, delta));
    }

    _countCell(v, r, kind) {
        const n = Number(v);
        if (!n) return '0';
        const safe = Util.escapeHtml(r.mem_name);
        return `<a href="javascript:void(0)" class="hb-order" data-mb="${r.mb_no}" data-name="${safe}" data-kind="${kind}">${this._comma(n)}</a>`;
    }

    async _openOrderModal(mbNo, name, kind = 'baljoo', bucket = null) {
        bucket = bucket || this.selectedBucket;
        if (!mbNo || !bucket) return;
        const unit = this.unit;
        this.orderModal = { mbNo, name, kind, bucket, unit };
        let res;
        try {
            res = await $.ajax({
                url: '/adm/ajax/stat/heavy-baljooja/orders', type: 'get',
                data: { mb_no: mbNo, unit, bucket, kind }
            });
        } catch (e) {
            console.error('오더목록 로드 실패', e);
            return;
        }
        if (!res || !res.ok) return;
        const rows = res.data || [];
        const k = kind === 'soojoo' ? '수주' : '발주';
        const title = `${name || ('#' + mbNo)} · ${this._fmtBucket(bucket)} ${k} 완료 ${this._comma(rows.length)}건`;
        // 이전/다음 이동 (차트 마지막 버킷 이후로는 다음 비활성)
        const last = this.trend.length ? String(this.trend[this.trend.length - 1].bucket) : null;
        const nav = {
            unitLabel: unit === 'year' ? '년' : '달',
            canPrev: true,
            canNext: last ? String(bucket) < last : true,
        };
        this._showOrders(title, rows, kind, nav);
    }

    async _openOrderRangeModal(mbNo, name, from, to, label, kind = 'baljoo') {
        if (!mbNo || !from || !to) return;
        this.orderModal = null; // 윈도우 모달은 이전/다음 이동 없음
        let res;
        try {
            res = await $.ajax({
                url: '/adm/ajax/stat/heavy-baljooja/orders-range', type: 'get',
                data: { mb_no: mbNo, from, to, kind }
            });
        } catch (e) {
            console.error('오더목록 로드 실패', e);
            return;
        }
        if (!res || !res.ok) return;
        const rows = res.data || [];
        const k = kind === 'soojoo' ? '수주' : '발주';
        const title = `${name || ('#' + mbNo)} · ${label}(${from} ~ ${to}) ${k} 완료 ${this._comma(rows.length)}건`;
        this._showOrders(title, rows, kind, null);
    }

    _showOrders(title, rows, kind = 'baljoo', nav = null) {
        const isSoo = kind === 'soojoo';
        const navHtml = nav ? `<div class="mb-2 d-flex align-items-center" style="gap:8px;">
            <button type="button" class="btn btn-sm btn-outline-secondary hb-ord-prev" ${nav.canPrev ? '' : 'disabled'}>← 이전${nav.unitLabel}</button>
            <button type="button" class="btn btn-sm btn-outline-secondary hb-ord-next" ${nav.canNext ? '' : 'disabled'}>다음${nav.unitLabel} →</button>
        </div>` : '';
        // 공용 오더목록 모달 (발주모달=수주자 / 수주모달=발주자 컬럼)
        this.$ordersTable = $j.F.Admin.Order.OrderListModal.show('hb-orders-modal', title, rows, {
            lastColTitle: isSoo ? '발주자' : '수주자',
            lastColField: isSoo ? 'bal_owner_name' : 'owner_name',
            lastColNoField: isSoo ? 'order_owner_num' : 'worker_owner_num',
            emptyName: isSoo ? '-' : '미배차',
            navHtml, pageLength: 10, emptyText: '완료 오더 없음',
        });
    }

    async _load(nocache = false) {
        const [unit, periods] = String($('#hbPeriod').val()).split(':');
        try {
            const res = await $.ajax({
                url: '/adm/ajax/stat/heavy-baljooja/data', type: 'get',
                data: { unit, periods, ...(nocache ? { nocache: 1 } : {}) }
            });
            if (!res.ok) return;
            this.minBaljoo = Number(res.min_baljoo) || 6;
            this.unit = res.unit === 'year' ? 'year' : 'month';
            this.trend = res.trend || [];
            $('#hbThreshold').text(this.minBaljoo);
            this._renderCards(this.trend);
            this._renderTrend(this.trend);
            if (res.cached_at) $('#hbCachedAt').text(`집계시각 ${res.cached_at}`);
            // 기본으로 마지막(진행중) 버킷 명단 표시
            if (this.trend.length) this._loadMembers(this.trend[this.trend.length - 1].bucket, nocache);
        } catch (e) {
            console.error('heavy 발주자 추이 로드 실패', e);
        }
        this._loadDeclining(nocache); // 기간과 무관(6h 캐시) — 갱신 시 함께 새로고침
    }

    async _loadDeclining(nocache = false) {
        const [unit, periods] = String($('#hbPeriod').val()).split(':');
        const bucket = this.selectedBucket || ''; // 그래프에서 선택한 시점 기준(as-of)
        $('#hbDeclCount').text('불러오는 중…');
        try {
            const res = await $.ajax({
                url: '/adm/ajax/stat/heavy-baljooja/declining', type: 'get',
                data: { unit, periods, bucket, ...(nocache ? { nocache: 1 } : {}) }
            });
            if (!res.ok) { this._renderDeclining([]); return; }
            const rm = Number(res.recent_months), pm = Number(res.past_months);
            this.declWindows = res.windows || null;
            const asOf = res.as_of ? `${this._fmtBucket(res.as_of)} 시점 기준 · ` : '';
            $('#hbDeclDesc').text(`— ${asOf}과거 ${pm}개월 월평균 6건+(완료) 이었으나 최근 ${rm}개월 70%+ 급감/중단`);
            this._renderDeclining(res.data || []);
        } catch (e) {
            console.error('발주 급감/중단 회원 로드 실패', e);
            this._renderDeclining([]);
        }
    }

    _renderDeclining(data) {
        $('#hbDeclCount').text(`총 ${this._comma(data.length)}명`);
        if (this.$declTable) { this.$declTable.destroy(); $('#hbDeclTable').empty(); }

        this.$declTable = new DataTable('#hbDeclTable', {
            data,
            columns: [
                { data: 'mem_name', title: '이름', render: (v, t, r) => this._nameCell(v, r) },
                { data: 'mem_car_type', title: '장비', render: (v, t, r) => this._equipCell(r) },
                { data: 'past_avg', title: '과거 월평균', render: (v, t, r) => this._declAvgCell(v, r, 'past', '과거') },
                { data: 'recent_avg', title: '최근 월평균', render: (v, t, r) => this._declAvgCell(v, r, 'recent', '최근') },
                { data: 'drop_pct', title: '감소율', render: (v) => `${v}%` },
                {
                    data: 'status', title: '상태',
                    render: (v) => v === 'stopped'
                        ? '<span class="badge" style="background:#dc3545;color:#fff;">중단</span>'
                        : '<span class="badge" style="background:#fd7e14;color:#fff;">급감</span>'
                },
                { data: 'last_baljoo', title: '마지막 작업', render: (v) => v || '-' },
            ],
            order: [], // 서버 정렬 유지(과거 대비 손실 발주량 많은 순)
            pageLength: 25,
            lengthChange: true,
            searching: true,
            autoWidth: false,
        });
    }

    async _loadMembers(bucket, nocache = false) {
        this.selectedBucket = bucket;
        const unit = this.unit;
        $('#hbMemTitle').text(`${this._fmtBucket(bucket)} heavy 발주자 명단`);
        $('#hbMemCount').text('불러오는 중…');
        try {
            const res = await $.ajax({
                url: '/adm/ajax/stat/heavy-baljooja/members', type: 'get',
                data: { unit, bucket, ...(nocache ? { nocache: 1 } : {}) }
            });
            if (!res.ok) { this._renderMembers([]); return; }
            this._renderMembers(res.data, unit);
        } catch (e) {
            console.error('heavy 발주자 명단 로드 실패', e);
            this._renderMembers([]);
        }
    }

    _renderCards(trend, bucket = null) {
        if (!trend || !trend.length) return;
        let cur = bucket ? trend.find(r => String(r.bucket) === String(bucket)) : null;
        if (!cur) cur = trend[trend.length - 1]; // 기본 = 마지막(진행중) 버킷
        const partial = Number(cur.is_partial) ? ' 진행중' : '';
        $('#hbCurMonth').text(`(${this._fmtBucket(cur.bucket)}${partial})`);
        $('#hbCntLabel').text('heavy 발주자');
        $('#hbCnt').text(this._comma(cur.heavy_cnt) + '명');
        $('#hbCntSub').text(this.unit === 'year' ? `월 ${this.minBaljoo}건+(완료) 경험` : `완료 발주 ${this.minBaljoo}건 이상`);
        $('#hbPct').text(cur.heavy_pct + '%');
        $('#hbPaid').text(this._comma(cur.orderers));
        $('#hbPaidSub').text(this.unit === 'year' ? '그 해 발주회원(distinct)' : '그 달 발주회원');
    }

    _renderTrend(trend) {
        const ctx = document.getElementById('hbTrendChart').getContext('2d');
        if (this.trendChart) this.trendChart.destroy();

        const labels = trend.map(r => this._fmtBucket(r.bucket));
        const counts = trend.map(r => Number(r.heavy_cnt));
        const pcts = trend.map(r => Number(r.heavy_pct));
        // 진행중(부분월) 막대는 옅게
        const barColors = trend.map(r => Number(r.is_partial) ? 'rgba(102,16,242,.35)' : 'rgba(102,16,242,.75)');

        this.trendChart = new Chart(ctx, {
            data: {
                labels,
                datasets: [
                    {
                        type: 'bar',
                        label: 'heavy 발주자 (명)',
                        data: counts,
                        backgroundColor: barColors,
                        yAxisID: 'y',
                        order: 2,
                    },
                    {
                        type: 'line',
                        label: '발주회원 중 heavy 비율 (%)',
                        data: pcts,
                        borderColor: '#fd7e14',
                        backgroundColor: 'rgba(253,126,20,.08)',
                        pointBackgroundColor: '#fd7e14',
                        pointRadius: 4,
                        tension: .25,
                        yAxisID: 'y1',
                        order: 1,
                    },
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: { mode: 'index', intersect: false },
                onClick: (evt, els, chart) => {
                    const pts = chart.getElementsAtEventForMode(evt, 'index', { intersect: false }, true);
                    if (!pts.length) return;
                    const r = trend[pts[0].index];
                    if (r) { this._renderCards(this.trend, r.bucket); this._loadMembers(r.bucket); this._loadDeclining(); } // 카드 + 좌측 명단 + 우측 급감표(그 시점 기준)
                },
                onHover: (evt, els, chart) => {
                    chart.canvas.style.cursor = els && els.length ? 'pointer' : 'default';
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        position: 'left',
                        title: { display: true, text: '인원수' },
                        ticks: { precision: 0 },
                    },
                    y1: {
                        beginAtZero: true,
                        position: 'right',
                        title: { display: true, text: '비율' },
                        grid: { drawOnChartArea: false },
                        ticks: { callback: v => v + '%' },
                    },
                },
                plugins: {
                    legend: { position: 'top' },
                    tooltip: {
                        callbacks: {
                            afterBody: (items) => {
                                const r = trend[items[0].dataIndex];
                                const partial = Number(r.is_partial) ? ' (진행중)' : '';
                                return `발주회원 ${this._comma(r.orderers)}명${partial}`;
                            }
                        }
                    }
                }
            }
        });
    }

    _renderMembers(data, unit = 'month') {
        data = data || [];
        $('#hbMemCount').text(`총 ${this._comma(data.length)}명`);
        if (this.$memTable) { this.$memTable.destroy(); $('#hbMemTable').empty(); }

        const isYear = unit === 'year';
        const baljooTitle = (isYear ? '연간발주' : '발주') + '<small class="text-muted">(완료)</small>';
        const soojooTitle = (isYear ? '연간수주' : '수주') + '<small class="text-muted">(완료)</small>';
        const columns = [
            { data: 'mem_name', title: '이름', render: (v, t, r) => this._nameCell(v, r) },
            { data: 'mem_car_type', title: '장비', render: (v, t, r) => this._equipCell(r) },
            { data: 'baljoo', title: baljooTitle, render: (v, t, r) => this._countCell(v, r, 'baljoo') },
            { data: 'soojoo', title: soojooTitle, render: (v, t, r) => this._countCell(v, r, 'soojoo') },
            {
                data: null, title: '수주/발주',
                render: (r) => {
                    const b = Number(r.baljoo), s = Number(r.soojoo);
                    return b > 0 ? (s / b).toFixed(2) : '-';
                }
            },
        ];
        if (isYear) {
            columns.push({ data: 'heavy_months', title: 'heavy 개월', render: (v) => `${this._comma(Number(v))}개월` });
        }

        this.$memTable = new DataTable('#hbMemTable', {
            data,
            columns,
            order: [[2, 'desc']], // 발주 많은 순
            pageLength: 25,
            lengthChange: true,
            searching: true,
            autoWidth: false,
        });
    }

    _navMember(dir) {
        const m = this.modal;
        if (!m.mbNo) return;
        const periods = m.unit === 'year' ? 10 : 24;
        this._openMemberModal(m.mbNo, m.name, m.unit, this._shiftBucket(m.endBucket, m.unit, dir * periods));
    }

    async _openMemberModal(mbNo, name, unit = 'month', endBucket = null) {
        if (!mbNo) return;
        unit = unit === 'year' ? 'year' : 'month';
        this.modal = { mbNo, name, unit, endBucket };
        const periods = unit === 'year' ? 10 : 24;

        let res;
        try {
            res = await $.ajax({
                url: '/adm/ajax/stat/heavy-baljooja/member', type: 'get',
                data: { mb_no: mbNo, unit, periods, ...(endBucket ? { end: endBucket } : {}) }
            });
        } catch (e) {
            console.error('회원 발주 추이 로드 실패', e);
            return;
        }
        if (!res || !res.ok) return;
        this.modal.endBucket = res.end_bucket; // 해소된 종료 버킷(이동 기준)

        const trend = res.trend || [];
        const first = trend.length ? String(trend[0].bucket) : null;
        const canPrev = first ? (unit === 'year' ? Number(first) > 2016 : first > '201601') : false;
        const canNext = String(res.end_bucket) < String(res.cur_bucket);
        const range = trend.length ? `${this._fmtBucket(trend[0].bucket)} ~ ${this._fmtBucket(res.end_bucket)}` : '';

        const title = `${res.mem_name || name || ('#' + mbNo)} 발주/수주 추이`;
        const html = `
            <div style="padding:6px 2px;">
                <div class="d-flex align-items-center justify-content-between mb-2">
                    <div class="btn-group btn-group-sm" role="group">
                        <button type="button" class="btn btn-outline-primary hb-member-unit ${unit === 'month' ? 'active' : ''}" data-u="month">월별</button>
                        <button type="button" class="btn btn-outline-primary hb-member-unit ${unit === 'year' ? 'active' : ''}" data-u="year">연별</button>
                    </div>
                    <div class="btn-group btn-group-sm" role="group">
                        <button type="button" class="btn btn-outline-secondary hb-mem-prev" ${canPrev ? '' : 'disabled'}>← 이전</button>
                        <span class="btn btn-sm disabled" style="pointer-events:none;">${range}</span>
                        <button type="button" class="btn btn-outline-secondary hb-mem-next" ${canNext ? '' : 'disabled'}>다음 →</button>
                    </div>
                </div>
                <div style="position:relative;height:300px;"><canvas id="hbMemberChart"></canvas></div>
            </div>`;
        $j.Ui.JBModal.html('hb-member-modal', html, Util.escapeHtml(title), { width: '620px' });

        // 모달 DOM 주입 후 차트 렌더
        const cv = document.getElementById('hbMemberChart');
        if (!cv) return;
        if (this.memberChart) { this.memberChart.destroy(); this.memberChart = null; }

        const labels = trend.map(r => this._fmtBucket(r.bucket));
        const baljoo = trend.map(r => Number(r.baljoo));
        const soojoo = trend.map(r => Number(r.soojoo));

        this.memberChart = new Chart(cv.getContext('2d'), {
            type: 'bar',
            data: {
                labels,
                datasets: [
                    { label: '발주', data: baljoo, backgroundColor: 'rgba(102,16,242,.75)', order: 2 },
                    { label: '수주', data: soojoo, backgroundColor: 'rgba(25,135,84,.75)', order: 2 },
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: { mode: 'index', intersect: false },
                scales: { y: { beginAtZero: true, ticks: { precision: 0 } } },
                plugins: { legend: { position: 'top' } }
            }
        });
    }

    _equipCell(r) {
        const car = String(r.mem_car_type || '').trim();
        if (car) return car;
        // 장비 없음 → 발주 주체 유형 표시 (mem_driver_type)
        const dt = String(r.mem_driver_type || '').trim();
        if (!dt) return '<span class="text-muted">-</span>';
        const color = dt === '업체발주자' ? '#6610f2' : (dt === '발주자' ? '#0d6efd' : '#6c757d');
        return `<span class="badge" style="background:${color};color:#fff;">${dt}</span>`;
    }

    /**
     * 이름 = 이 화면의 발주 추이 모달 (그대로 둔다) · #번호 = 회원 팝오버.
     * 이름을 팝오버로 바꾸면 이 표에서 가장 자주 누르는 추이가 한 번 더 멀어진다.
     */
    _nameCell(v, r) {
        const name = v == null ? '-' : String(v);
        const safe = Util.escapeHtml(name);
        return `<a href="javascript:void(0)" class="hb-name" data-mb="${r.mb_no}" data-name="${safe}">${safe}</a>`
            + ` <small class="text-muted">#${$j.F.Admin.Member.Pop.cellNo(r.mb_no)}</small>`;
    }

    // 급감표 과거/최근 월평균 셀 — 클릭 시 그 윈도우 발주 오더목록 모달
    _declAvgCell(v, r, key, label) {
        const text = `${v}건`;
        const w = this.declWindows && this.declWindows[key];
        if (!w) return text;
        const safe = Util.escapeHtml(r.mem_name);
        return `<a href="javascript:void(0)" class="hb-range" data-mb="${r.mb_no}" data-name="${safe}" data-from="${w.from}" data-to="${w.to}" data-label="${label}">${text}</a>`;
    }

    _fmtBucket(b) {
        const s = String(b);
        if (s.length === 6) return `${s.slice(0, 4)}.${s.slice(4)}`; // YYYYMM
        if (s.length === 4) return `${s}년`;                          // YYYY
        return s;
    }

    _comma(n) {
        return Number(n || 0).toLocaleString();
    }

    destroy() {
        if (this.trendChart) { this.trendChart.destroy(); this.trendChart = null; }
        if (this.memberChart) { this.memberChart.destroy(); this.memberChart = null; }
        if (this.$memTable) { this.$memTable.destroy(); this.$memTable = null; }
        if (this.$declTable) { this.$declTable.destroy(); this.$declTable = null; }
        $j.F.Admin.Order.OrderListModal.destroy(); this.$ordersTable = null;
        $(document).off('.hbname');
        if ($j.Ui.JBModal) $j.Ui.JBModal.close();
    }
}
